module.exports = __webpack_public_path__ + "c1566b257e4b97bcdcf4bd75eb638a05.svg";